import React from "react";

export default ({ children }) => (
  <div className="max-w-6xl mx-auto	bg-white dark:bg-gray-850 dark:text-gray-300">
    {children}
  </div>
);
